import Vue from 'vue'
import Lodash from 'lodash'
import { getScrollbarWidth } from '@/utils/index.js';
// vxetable表头吸顶固定
const fixedTableHeader = (el, binding, vnode) => {
    // const appDom=document.querySelector('#app')
    // 是否在吸顶的状态
    let isfixed = false
    let scrollBarWidth = getScrollbarWidth()

    const appDom = window.document
    el._customTemp_ = {}
    // 普通的列表列吸顶
    const colDom = el.querySelector(`.vxe-table--header-wrapper`)
    if (!colDom) {
        delete el._customTemp_
        console.log('未找到表头无法固定');
        return
    }
    // 检查是否存在横向滚动
    let isScrollX = el.querySelector('.vxe-table--main-wrapper .body--wrapper')?.getBoundingClientRect()?.width < el.querySelector('.vxe-table--main-wrapper .body--wrapper .vxe-table--header')?.getBoundingClientRect()?.width || false
    //console.log('isScrollX :>> ', isScrollX);
    // 左侧固定列
    let nodeLeft = el.querySelector(`.vxe-table--fixed-left-wrapper .vxe-table--header`)
    let nodeLeftRect = nodeLeft?.getBoundingClientRect();
    // vxe表格的固定列会有隐藏的表头盖住正常的表头，需要穿透
    if (nodeLeft) {
        nodeLeft.style['pointer-events'] = 'none'
        // 正常固定的表头恢复可点击
        nodeLeft?.querySelectorAll('.vxe-header--row>.col--fixed').forEach(item => {
            item.style['pointer-events'] = 'auto'
        })
    }
    if (nodeLeft && isScrollX) {
        // 添加固定列的样式
        el.querySelector(`.vxe-table--fixed-left-wrapper`).classList.add('custom-fixed-style')
        // 设置顶部滚动条的偏移量
        let tableBodyLeft = el.querySelector(`.vxe-table--fixed-left-wrapper .vxe-table--body-wrapper.fixed-left--wrapper`)
        tableBodyLeft.style['transform'] = `translateY(${scrollBarWidth}px)`
    }

    // 右侧固定列
    let nodeRight = el.querySelector(`.vxe-table--fixed-right-wrapper .vxe-table--header`)
    if (nodeRight && isScrollX ) {
        // 添加固定列的样式
        el.querySelector(`.vxe-table--fixed-right-wrapper`).classList.add('custom-fixed-style')
        // 设置顶部滚动条的偏移量
        let tableBodyRight = el.querySelector(`.vxe-table--fixed-right-wrapper .vxe-table--body-wrapper.fixed-right--wrapper`)
        tableBodyRight.style['transform'] = `translateY(${scrollBarWidth}px)`
    }

    let nodeRightRect = nodeRight?.getBoundingClientRect();
    if (nodeRight) {
        nodeRight.style['pointer-events'] = 'none'
        nodeRight.querySelectorAll('.vxe-header--row>.col--fixed').forEach(item => {
            item.style['pointer-events'] = 'auto'
        })
    }
    let fixedRight = nodeRightRect ? Math.floor(document.documentElement.clientWidth - nodeRightRect.right) : 0


    // 注意处理滚动条宽度
    let headerWidth = el?.getBoundingClientRect().width || 0
    // console.log('headerWidth',headerWidth)
    let headerHeight = colDom?.getBoundingClientRect().height || 48
    const tableBody = el.querySelector('.vxe-table--main-wrapper')
    // 如果表格有横向滚动，那表头整体高度要留出下方的滚动条的像素
    if (isScrollX) {
        headerHeight + scrollBarWidth
    }
    const scrollTableDom = el.querySelector('.vxe-table--body-wrapper.body--wrapper')
    colDom.style['overflow-x'] = 'auto'

    // 设置监听表格宽度变化
    el._customTemp_.resizeObserver = new ResizeObserver(entries => {
        for (let entry of entries) {
            const cr = entry.contentRect;
            // console.log('Size:', cr.width, 'x', cr.height);
            headerWidth = cr.width
            // 如果在吸顶的途中变动了表格宽度，立即调整表头的宽度
            if (isfixed) {
                colDom.style.width = headerWidth + 'px'
            }
        }
    });
    el._customTemp_.resizeObserver.observe(el);

    el._customTemp_.onScroll = Lodash.throttle((e) => {
        try {
            let tableBodyRect = tableBody?.getBoundingClientRect()

            // 当表格top大于0说明不需要吸顶,当滚动的距离大于整个表格高度时,取消吸顶
            if (tableBodyRect.top >= 0 || tableBodyRect.top * -1 > tableBodyRect.height - headerHeight) {
                isfixed = false
                // 必须还原样式，否则定位会不准
                if (colDom) {
                    colDom.parentNode.style['padding-top'] = ''
                    colDom.style.position = ''
                    colDom.style.top = 'unset'
                    colDom.style['z-index'] = 'unset'
                    colDom.style.width = ''
                }
                if (nodeLeft) {
                    nodeLeft.style.position = ''
                    nodeLeft.style.top = 'unset'
                    nodeLeft.style.left = 'unset'
                    nodeLeft.style['z-index'] = 'unset'
                }
                if (nodeRight) {
                    nodeRight.style.position = ''
                    nodeRight.style.top = 'unset'
                    nodeRight.style.right = 'unset'
                    nodeRight.style['z-index'] = 'unset'
                }
            } else {
                isfixed = true
                if (nodeLeft) {
                    nodeLeft.style.position = 'fixed';
                    nodeLeft.style.top = '0px';
                    nodeLeft.style.left = nodeLeftRect.left + 'px';
                    nodeLeft.style['z-index'] = 110;
                }
                if (nodeRight) {
                    nodeRight.style.position = 'fixed';
                    nodeRight.style.top = '0px';
                    nodeRight.style.right = fixedRight + 'px'; //要根据是否存在滚动条去设置
                    nodeRight.style['z-index'] = 110;
                }
                if (colDom) {
                    colDom.parentNode.style['padding-top'] = headerHeight + 'px'
                    colDom.style.width = headerWidth + 'px'
                    colDom.style.position = 'fixed';
                    colDom.style.top = '0px'
                    colDom.style['z-index'] = 1
                }
            }
        } catch (error) {
            console.log('固定表头err',error);
        }
    }, 1000 / 120)
    appDom.addEventListener("scroll", el._customTemp_.onScroll)
    el._customTemp_.onScrollX = function(e) {
        let curLeft = e.target.scrollLeft
        scrollTableDom.scrollLeft = curLeft
    }
    colDom.addEventListener("scroll", el._customTemp_.onScrollX)

}
Vue.directive("fixed-table-header", {
    bind(el, binding, vnode) {
        setTimeout(fixedTableHeader(el, binding, vnode), 1500);
    },
    unbind(el, binding) {
        // const appDom=document.querySelector('#app')
        const appDom = window.document
        if (el?._customTemp_?.onScroll) {
            appDom.removeEventListener('scroll', el._customTemp_.onScroll)
            delete el._customTemp_.onScroll
        }
        if (el?._customTemp_?.onScrollX) {
            const colDom = el.querySelector(`.vxe-table--header-wrapper`)
            colDom.removeEventListener('scroll', el._customTemp_.onScrollX)
            delete el._customTemp_.onScrollX
        }
        if (el._customTemp_.resizeObserver) {
            el._customTemp_.resizeObserver.disconnect();
        }
    },
    update(el, binding, vnode) {
        // console.log('componentUpdated');
        const appDom = window.document
        if (el?._customTemp_?.onScroll) {
            appDom.removeEventListener('scroll', el._customTemp_.onScroll)
            delete el._customTemp_.onScroll
        }
        if (el?._customTemp_?.onScrollX) {
            const colDom = el.querySelector(`.vxe-table--header-wrapper`)
            colDom.removeEventListener('scroll', el._customTemp_.onScrollX)
            delete el._customTemp_.onScrollX
        }
        if (el._customTemp_.resizeObserver) {
            el._customTemp_.resizeObserver.disconnect();
        }
        fixedTableHeader(el, binding, vnode)
    },
})
// vxetable表头吸顶固定 end